class RechargeRequestError {
  constructor(message, status) {
    this.name = "RechargeRequestError";
    this.message = message;
    this.status = status;
  }
}

export { RechargeRequestError };
//# sourceMappingURL=error.js.map
